import {HttpVerbo, xfetch} from "../util";

export default class ItemDemandaServico {

  static getItens = () => {
    return xfetch('/demanda/itens', {}, HttpVerbo.GET)
      .then(res => res.json())

  }

  static cadastrarItem = (item) => {
    return xfetch('/demanda/item/cadastrar', item, HttpVerbo.POST)
      .then(res => res.json())
  }
}